/**
* Click to Play JS
* -----------------------------------------------------------------------------
*
* All the JS for the Click to Play component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';
gsap.registerPlugin( DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {

    className: 'click-to-play',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const svg = document.querySelector( '.click-to-play__btn-circle circle' );

      if ( svg ) {
        const tl = gsap.timeline( {paused: true} )
            .set( svg, {autoAlpha: 1} )
            .from( svg, {drawSVG: 0, ease: 'none'} );

        svg.onmouseenter = () => tl.play();
        svg.onmouseleave = () => tl.reverse();
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'click-to-play', COMPONENT );
} )( app );
